import apiClient from "../apiClient";
import { API_ROUTES } from "../../config/baseURL";

export const getIndicadoresGob = async (filtros, seccion) => {
  const query = new URLSearchParams();

  if (seccion) query.append("seccion", seccion);

  Object.entries(filtros || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const normalized = Array.isArray(value) ? value.join(",") : String(value);
    if (normalized !== "") query.append(key, normalized);
  });

  const qs = query.toString();
  const url = qs ? `${API_ROUTES.indGobIndicadores}?${qs}` : API_ROUTES.indGobIndicadores;

  const res = await apiClient.get(url);
  return res.data;
};

export const getConfiguracionIndGob = async () => {
  const res = await apiClient.get(API_ROUTES.indGobConfig);
  return res.data;
};

export const getCatalogoFiltroIndGob = async (idFiltro, params = {}) => {
  const query = new URLSearchParams({ idFiltro, ...params });
  const res = await apiClient.get(`${API_ROUTES.indGobCatalogoFiltro}?${query.toString()}`);
  return res.data;
};
